import { head } from 'lodash'
import {
    usoCfdiValores,
    formaPagoValores,
    MetodoPagoValores,
    MonedaValores
} from '../data/catalogs/CatalogosSAT'

const getMatchedOption = (options = [], value) => {
    if (!value) {
        return null
    }

    return head(options.filter((option) => option.value === value)) || null
}

const getMatchedCustomer = (clientes = [], receptor = {}) => {
    if (!receptor?.rfc) return null
    return clientes.find(c => c.rfc === receptor.rfc) || null
}

/**
 * Transforms a cerrar-saldo prefill payload (from the API) into the
 * hydration shape expected by Form.js — matching the output of
 * getDuplicatedFacturaFormState() in duplicarFactura.js.
 *
 * @param {Object} prefillData – the `prefill` object returned by
 *   POST /api/facturas/:id/cerrar-saldo-prefill
 * @param {Array}  clientes    – the loaded clientes list from Form.js
 */
export const buildCerrarSaldoPrefill = (prefillData, clientes = []) => {
    const metodoPago = getMatchedOption(MetodoPagoValores, prefillData?.metodoPago || 'PUE')
    const formaPago = getMatchedOption(formaPagoValores, prefillData?.formaPago)

    return {
        cliente: getMatchedCustomer(clientes, prefillData?.receptor),
        usoCFDI: getMatchedOption(usoCfdiValores, prefillData?.usoCFDI || 'G02'),
        metodoPago,
        formaPago,
        moneda: getMatchedOption(MonedaValores, prefillData?.moneda || 'MXN'),
        tipoCambio: prefillData?.tipoCambio ?? '',
        lineItems: Array.isArray(prefillData?.lineItems) ? prefillData.lineItems : [],
        tipoDeComprobante: prefillData?.tipoDeComprobante || 'E',
        cfdiRelacionados: Array.isArray(prefillData?.cfdiRelacionados)
            ? prefillData.cfdiRelacionados
            : [],
        _sourceFacturaId: prefillData?._sourceFacturaId || null
    }
}
